/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import UserCredentials from "./UserCredentials.container";

export default UserCredentials;
